import _ from 'lodash'
import { getStatements } from '../../i18n/Statements'
import { Assignation,} from '../types'
import { ALL_CATS } from '../../utils/values/cats'
import { info } from '../../services/sentryLogger'
import { FullParameters, Scanning360Params } from '../../parameters/types'
import { NO_SCORE, AnswserScoreType, FINAL_NPS_KEY } from '../../services/types'
import { doShuffle } from './arrays'
import { AUTO_ENTRY } from '../../parameters/parameters'
import { STM } from '../types'

export const ALL_CATS_NO_MACHT = ALL_CATS.filter((c) => c !== 'macht')

/**
 * side effect : Will modify params
 * FIXME : prepareRounds360
 * @param params
 * @returns
 */
export const prepareRounds = (params: FullParameters) => {
    info('prepareRounds() - Init deck and misc', params)
    const nRounds = params.assessmentParams['Nb of rounds']
    const nValues = params.assessmentParams['Nb of values']
    params.assessmentParams['Deck size'] = nValues * nRounds
    params.assessmentParams['Buckets'] =
        params.assessmentParams['Buckets'] === AUTO_ENTRY.v ? nValues : params.assessmentParams['Buckets'] // FIXME here

    const {
        assessmentParams: {
            is360 = false,
            is360WithLeadership,
            is360WithWorkenv,
        },
    } = params
    // FIXME prepareRounds360
    const params360: Scanning360Params = {
        is360,
        is360WithLeadership,
        is360WithWorkenv,
    }
    console.debug('prepareRounds()', { params360 })
    const allStms = getStatements(params.assessmentParams['langIndex'], params360)
    // could be empty
    const allStmsLeadership = doShuffle(
        allStms.filter((a) => a.preferredType360 === 'leadership')
    )    

    // could be empty
    const allStmsWorkenv = doShuffle(
        allStms.filter((a) => a.preferredType360 === 'workenv')
    )    
    const subCats = doShuffle(is360 ? ALL_CATS_NO_MACHT : ALL_CATS).slice(
        0,
        nValues
    )   

    const onePerType = subCats.map((cat) =>
        doShuffle(allStms.filter((stm) => stm.category === cat)).slice(
            0,
            nRounds
        )
    )

    const initialRounds: Assignation[][] = onePerType
        .reduce((acc, stms) => {
            stms.forEach((stm, index) => {
                acc[index] = [
                    ...(acc[index] ?? []),
                    {
                        ...stm,
                        roundNumber: index + 1,
                    },
                ]
            })
            return acc
        }, [] as Assignation[][])
        .map(doShuffle)        
    const asgnsRound2Rank = _.cloneDeep(initialRounds)

    const scannedItems: AnswserScoreType[] = allStms.map((stm) => ({
        RefQuestion: stm.valueKey,
        Score: NO_SCORE, // mean
    })); 

    return {
        initialRounds,
        asgnsRound2Rank,
        // FIXME rename
        allStms: {
            leadership: allStmsLeadership,
            workenv: allStmsWorkenv,
        } as Record<STM['preferredType'], Assignation[]>,
        scannedItems: [
            ...scannedItems,
            ({
                RefQuestion: FINAL_NPS_KEY,
                Score: NO_SCORE,
            }) as AnswserScoreType,
        ],
    }
}
